import _ from 'lodash';
import moment from 'moment';
import { isEmptyValue, Marshall, loadFiltersForReport } from 'utils/filter';
import * as C from './constants';

const isObject = (v) => !_.isArray(v) && _.isObject(v) && !(v instanceof moment);

const isArrayOfObjects = (v) => _.isArray(v) && v.every(isObject);

const isObjectWithIntegerKeys = (v) => Object.keys(v).every((i) => _.isInteger(Number(i)));

export const sanitize = (filters) => {
  const sanitizedFilters = {};
  _.forEach(filters, (v, k) => {
    if (isObject(v)) {
      const sanitizedValue = sanitize(v);
      if (!isEmptyValue(sanitizedValue)) {
        sanitizedFilters[k] = sanitizedValue;
      }
    } else if (!isEmptyValue(v)) {
      sanitizedFilters[k] = v;
    }
  });
  return sanitizedFilters;
};

// Iterate over a filter object to replace array of objects such as
//   [{ name: 'chain', value: ['Edeka', 'Rewe'] }, { ... }]
// by an object with integer keys to be consumed by the API, such as:
//   {0: { name: 'chain', value: ['Edeka', 'Rewe'] }, 1: { ... }}
export const arrayToObject = (filter) => {
  const newFilter = {};
  _.forEach(filter, (v, k) => {
    if (isObject(v)) {
      newFilter[k] = arrayToObject(v);
    } else if (isArrayOfObjects(v)) {
      const newValue = {};
      _.forEach(v, (value, i) => {
        newValue[i] = value;
      });
      newFilter[k] = newValue;
    } else {
      newFilter[k] = v;
    }
  });
  return newFilter;
};

// Iterate over a filter object from the API to replace objects such as
//   {0: { name: 'chain', value: ['Edeka', 'Rewe'] }, 1: { ... }}
// by an array of object to be consumed by Redux Form, such as:
//   [{ name: 'chain', value: ['Edeka', 'Rewe'] }, { ... }]
export const objectToArray = (filter) => {
  const newFilter = {};
  _.forEach(filter, (v, k) => {
    if (isObject(v)) {
      if (isObjectWithIntegerKeys(v)) {
        newFilter[k] = Object.values(v);
      } else {
        newFilter[k] = objectToArray(v);
      }
    } else {
      newFilter[k] = v;
    }
  });
  return newFilter;
};

const objectify = (flattenedFilters) => {
  const filters = {};
  _.forEach(flattenedFilters, (v, k) => {
    const dottedK = k.replace(/__/g, '.');
    _.set(filters, dottedK, v);
  });
  return filters;
};

export const toggle = () => ({ type: C.TOGGLE_FILTER });

export const setFilters = (reportId, filters = {}) => (dispatch) => {
  const sanitizedFilters = sanitize(filters);
  const marshalledFilters = JSON.stringify(Marshall.apply(objectify(sanitizedFilters)));
  localStorage.setItem(`filters_${reportId}`, marshalledFilters);
  return dispatch({ type: C.SET_FILTERS, data: sanitizedFilters });
};

export const loadFilters = (reportId) => (dispatch) => {
  const filters = loadFiltersForReport(reportId);
  return dispatch({ type: C.LOAD_FILTERS, data: filters });
};
